import { IGetWithdrawalRequest, IWithdrawalsResponse, TFile } from '../types/WithdrawalsTypes';
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery, getBaseQueryWithReauth } from 'redux/baseQueryAuth';

type UpdateWithdrawalStatusResponse = {
  // сервер возвращает номер страницы для перехода
  redirect?: number;
};

export const WithdrawalsApi = createApi({
  reducerPath: 'WithdrawalsApi',
  tagTypes: ['Withdrawals'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    getWithdrawals: build.query<IWithdrawalsResponse, IGetWithdrawalRequest>({
      query: (params) => ({
        params: {
          status: params?.status || undefined,
          page_size: params?.page_size || 0,
          page: params?.page || 1,
          id: params?.id || undefined,
        },
        url: '/withdrawals/',
        method: 'GET',
      }),
      providesTags: ['Withdrawals'],
    }),

    updateWithdrawalStatus: build.mutation<
      UpdateWithdrawalStatusResponse,
      { body: FormData; id: string }
    >({
      query: ({ body, id }) => ({
        url: `/withdrawals/${id}/change_withdrawal/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Withdrawals'],
    }),

    getFiles: build.query<{ files: TFile[] }, { id: string }>({
      query: (params) => ({
        url: `/withdrawals/${params.id}/file/`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetWithdrawalsQuery,
  useUpdateWithdrawalStatusMutation,
  useGetFilesQuery,
} = WithdrawalsApi;
